module.exports = __webpack_public_path__ + "static/yukyung.kang-c3c6b46fa56723248b252b6810f6c036.jpeg";